import { throwError } from 'rxjs';
import { CmEventService } from '../services/cm-events.service';
import { LoadEventHandler } from './load-event-handler';

export const loadEventInitializer = (events: CmEventService, id: string): LoadEventHandler => {
	return {
		onLoad: () => events.handleLoadingChange(id, 'START'),
		onUnload: () => events.handleLoadingChange(id, 'END'),
		onError: (error: any) => throwError(() => error),
	};
};
